<template>
  <div id="welcome">
    <div style="background: #fff; overflow: hidden">
      <SearchQuery :pageSize="pageSize" :isReports="reportPage" :currentPage="currentPage" :searchName="searchName"
        ref="search" class="search-content" @getBaseId='getProBaseId'>
        <span>
          <el-button type="primary" icon="el-icon-search" size="small" style="margin-left:15px" @click="getSearch">{{
            $t("message.button.taskstatement") }}
          </el-button>
          <el-button type="primary" icon="el-icon-zoom-in" size="small" style="margin-left:15px"
            @click="getSearchPerformance">{{ $t("message.button.executorstatement") }}
          </el-button>
          <el-button type="primary" icon="el-icon-zoom-in" size="small" style="margin-left:15px" @click="getxx">{{
            $t("message.button.remark") }}
          </el-button>
        </span>
      </SearchQuery>
      <div style="height: 6px; background: #ebebeb"></div>
    </div>
    <div class="search_cotent">
      <el-card>
        <!-- <div class="header_title" style="margin:-16px 0 -10px -35px">
          <TitleTag>
            <span slot="title" style="font-weight:600">
              {{$t('message.title.searchResult')}}
            </span>
          </TitleTag>
        </div> -->

        <div v-loading="loading">
          <vxe-grid v-bind="gridOptions" resizable ref="table" :print-config="{}" :toolbar-config="tableToolbar">
            <vxe-toolbar> </vxe-toolbar>
            <template #tools>
              <el-button @click="exportBOM" size="small" icon="el-icon-download" :disabled='!gridOptions.data.length'
                style="margin-right: 15px;">
                {{ $t("message.button.exportAll") }}
              </el-button>
            </template>
          </vxe-grid>

          <!-- <el-pagination
            small
            class="pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="pageSizes"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalRols"
          >
          </el-pagination> -->
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import NProgress from "nprogress"; // 引入nprogress插件
import "nprogress/nprogress.css";
import TitleTag from "@/components/titleTag";
import SearchQuery from "@/views/workBench/search/searchItem/search.vue";
import axios from "axios";
import XEUtils from "xe-utils";
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  name: "classes",
  data() {
    return {
      searchName: "",
      buttonName: '',
      checked: false,
      loading: false,
      reportPage: true,

      pageSizes: [100, 200, 500, 1000],
      pageSize: 100,
      currentPage: 1,
      // searchBaseId:'',

      totalRols: "",
      search_data: "",
      get_data: [],
      selectGroup: [],
      select_value: "",

      tableToolbar: {
        buttons: [{ code: "myInsert", name: "", type: "text" }],
        print: true,
        export: true,
        zoom: true,
        custom: true,
        slots: {
          tools: "tools",
        },
      },
      isPro: false,
      gridOptions: {
        border: true,
        resizable: true,
        showOverflow: true,
        treeConfig: {},
        // stripe: true,
        height: 660,
        align: "left",
        highlightHoverRow: true,
        columns: [],
        data: [],
      },
    };
  },
  components: {
    SearchQuery,
    TitleTag,
  },
  mounted() {
    this.$store.commit('setIncludesList', 'classes');
    this.$nextTick(() => {
      this.$refs.table.setAllTreeExpand(true)
    })
  },
  methods: {
    // handleSizeChange(val) {
    //   this.pageSize = val
    // },
    // handleCurrentChange(val) {
    //   this.currentPage = val;

    // },

    exportBOM() {
      NProgress.start();
      // 对数据预处理
      const column = this.$refs.table.getColumns();
      const columnTitle = column.map((i) => i.title);
      const columnId = column.map((i) => i.property);
      let data = [];
      data.push(columnTitle);

      // console.log(this.$refs.table.getTableData());
      console.log(this.visiableData);

      this.visiableData.map((i) => {
        let n = [];
        // if (Array.isArray(i)) {
        //   data.push([])
        // }
        columnId.map((j) => {
          n.push(i[j]);
        });
        data.push(n);
      });
      // 转换数据
      let book = XLSX.utils.book_new();
      let sheet = XLSX.utils.json_to_sheet(data, { skipHeader: true });
      XLSX.utils.book_append_sheet(book, sheet);
      let wbout = XLSX.write(book, {
        bookType: "xlsx",
        bookSST: false,
        type: "binary",
      });
      let blob = new Blob([this.toBuffer(wbout)], {
        type: "application/octet-stream",
      });
      // 保存导出
      FileSaver.saveAs(blob, this.buttonName + "标准报表.xlsx");
      NProgress.done();
    },
    getSearch() {

      const obj = this.$refs.search.getSearchInfo();
      this.$refs.search.searchShow = false;
      this.loading = true;
      this.gridOptions.columns = [];
      this.gridOptions.data = [];
      this.gridOptions.treeConfig = { children: 'children' };
      this.tableToolbar.buttons[0].name = "";

      axios.post('/ppm/projectStatus/searchProjectAndExportExcel', obj).then((res) => {
        console.log(res);
        let columnlist = [], listData = [];
        this.loading = false;
        if (res.data.object.result.length) {
          // const data = res.data.object.result.filter(i =>!i.rows[0].parentRowId)
          const data = res.data.object.result
          // console.log(data);
          columnlist = data[0].columnInfo.names.map((i, e) => {
            return {
              title: i,
              field: parseInt(data[0].columnInfo.ids[e]),
              minWidth: "140",
              sortable: true
            };
          });
          let tempData = data.map(i => i.rows[0])
          this.getSeq(this.getAllRows(tempData, columnlist)).map(i => {
            // listData.push([]);
            listData.push(i)
          })
          // listData.shift()
          columnlist.unshift({ field: 'sqe', title: '序号', minWidth: 75, })
          columnlist[1].treeNode = true;

          this.gridOptions.columns = columnlist;
          // this.gridOptions.treeConfig = { children: "children", expandAll: true,transform:true},
          this.gridOptions.data = listData;
          this.visiableData = this.getAllRow(listData);
        }
        this.tableToolbar.buttons[0].name = this.$t('message.title.totalResults') + this.visiableData.length + this.$t('message.title.resultsNums');
      });
    },
    getSearchPerformance() {
      const obj = this.$refs.search.getSearchInfo();
      this.$refs.search.searchShow = false;
      this.loading = true;
      this.gridOptions.treeConfig = {};
      axios.post('/ppm/projectStatus/searchProjectTeamAndExportExcel', obj).then(res => {
        if (res.data.code == 200) {
          let columnlist = [], listData = [];

          const data = res.data.object?.result;
          console.log(data);
          this.loading = false;
          if (data) {
            console.log(data);
            const columnsFieldList = data.columnInfo.columns;
            columnlist = data.columnInfo.names.map((i, e) => ({
              title: i,
              field: columnsFieldList[e].replace(".", "_"),
              minWidth: 140,
              sortable: true
            }))
            console.log(columnlist);
            let tempRows = data.rows.map(i => i.cells).filter(i => i.length)
            const listData = tempRows.map(i => {
              const obj = {};
              i.map((j, e) => {
                let val = j.val ?? '';
                if (j.hasOwnProperty('date')) {
                  val = val.split('T')[0];
                }
                obj[columnlist[e]['field']] = val
              })
              return obj
            })

            this.gridOptions.columns = columnlist;
            this.gridOptions.data = listData;
            this.visiableData = listData;
          }
          this.tableToolbar.buttons[0].name = this.$t('message.title.totalResults') + listData.length + this.$t('message.title.resultsNums');
        } else {
          this.$message.error(res.data.message)
        }
        this.loading = false;
      })
    },

    getxx() {

      const obj = this.$refs.search.getSearchInfo();
      this.$refs.search.searchShow = false;
      this.loading = true;
      this.gridOptions.columns = [];
      this.gridOptions.data = [];
      this.tableToolbar.buttons[0].name = "";

      axios.post('/ppm/projectStatus/searchProjectRecordAndExportExcel', obj).then((res) => {
        console.log(res);
        let columnlist = [],
          listData = [];
        this.loading = false;
        if (res.data.object.result.rows.length) {
          const data = res.data.object.result
          columnlist = data.columnInfo.names.map((i, e) => {
            return {
              title: i,
              field: parseInt(data.columnInfo.ids[e]),
              minWidth: 140,
              sortable: true
            };
          });
          listData = data.rows.map((i, m) => {
            let n = {};

            columnlist.map((j, e) => {
              // if (!i.cells[e].val) {
              //   console.log(m);
              // }
              let val = i.cells[e]?.val ?? '';
              if (i.cells[e]?.date) {
                val = val.split('T')[0];
              }
              Object.assign(n, { [j.field]: val })
            })
            return n
          });
          console.log(listData);

          // columnlist.unshift({field:'sqe',title:'序号',minWidth:75})
          // columnlist[1].treeNode = true;

          this.gridOptions.columns = columnlist;
          // this.gridOptions.treeConfig = { children: "children", expandAll: true,transform:true},
          this.gridOptions.data = listData;
          // this.visiableData = this.getAllRow(listData);
          this.tableToolbar.buttons[0].name = this.$t('message.title.totalResults') + listData.length + this.$t('message.title.resultsNums');
          // '共搜索到 '+ listData.length+ '条数据'
        } else {
          this.tableToolbar.buttons[0].name = this.$t('message.title.totalResults') + "0" + this.$t('message.title.resultsNums');
        }

      });
    },

    getProBaseId(e) {
      console.log(e);
      this.isPro = e.value == 301;
      this.buttonName = e.label;
    },

    getSeq(array, l, n,) {
      if (!array || !array.length) return;
      let level = l || 1;
      let parentLevel = n || 0;
      array.forEach((item, e) => {
        item.sqe = !parentLevel ? (e + 1 + '') : parentLevel + '.' + (e + 1 + '')
        // if (level == 1) {
        //   item.sqe = '1'
        // }
        if (item.children && item.children.length) {
          this.getSeq(item.children, level + 1, item.sqe);
        }
      })
      return array;
    },

    getAllRows(arr, columns) {
      // console.log(arr);
      let newArr = [];
      // let L = isLeaf || false;
      arr.map((i, e) => {
        let n = this.getRow(i, columns);
        // console.log(i);
        newArr.push(n);
        if (!i.isLeaf && i.children) {
          n.children = this.getAllRows(i.children, columns);
        } else {
          n.children = [];
        }
      });
      return newArr;
    },
    getRow(arr, columns) {
      let n = {};
      // console.log(this.gridOptions.columns);
      n.objId = arr.objId;
      n.id = arr.objId;
      n.parentId = arr.parentRowId;
      columns.map((i, e) => {
        // console.log(arr);
        let val = arr.cells[e]?.val ?? '';
        if (arr.cells[e]?.date) {
          val = val.split('T')[0];
        }
        Object.assign(n, { [i.field]: val });
      });
      // console.log(n);
      return n;
    },
  },

};
</script>

<style scoped>
.pagination {
  margin-top: 15px;
  text-align: left;
}

.search-condition {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  margin-left: 10px;
}

.search-title {
  /* width: 120px; */
  padding-right: 120px;
  margin-left: 15px;
}

.search-content {
  margin: 10px 10px;
}

.btn {
  display: inline-block;
  padding: 3px;
  padding-right: 10px;
  border: 1px solid #000;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn6 {
  height: 32px;
  /* line-height: 32px; */
  color: #f5a521;
  border-color: rgba(245, 165, 33, 0.5);
  background: rgba(245, 165, 33, 0.2);
  margin: 0;
  position: relative;
  /* top: 2px; */
}

.btn6:hover {
  color: #fff;
  background: rgba(245, 165, 33, 0.4);
}

.el-selector-search {
  width: 18px;
}
</style>
